import { BiGlobe } from "react-icons/bi";
import { IoIosCalculator } from "react-icons/io";
import { HiOutlineDocumentReport } from "react-icons/hi";
import { MdOutlineAlternateEmail, MdDone } from "react-icons/md";
import { ReactComponent as IntegrationIcon } from "../../assets/icons/icon-integracao.svg";

interface Feature {
  name: string;
  desc?: string;
  icon?: JSX.Element;
  secondaryIcon?: JSX.Element;
  secondaryLabel?: string;
}

export enum PlanEnum {
  BASIC_V1 = "BASIC_V1",
  PRO_V1 = "PRO_V1",
}

export interface Plan {
  type: PlanEnum | UserPlanEnum;
  title: string;
  price: number;
  discount: number;
  originalPrice: number;
  includedFeatures: Feature[];
  otherFeatures: Feature[];
}

export const OtherFeatures: Feature[] = [
  {
    name: "Emissão de relatório anual (DASN-MEI)",
  },
  {
    name: "Emissão de guias mensais (DAS)",
  },
];

export enum UserPlanEnum {
  VELOTAX_MAIN_BASIC = "VELOTAX_MAIN_BASIC",
  VELOTAX_MAIN_BASIC_MONTH = "VELOTAX_MAIN_BASIC_MONTH",
  VELOTAX_MAIN_FREE = "VELOTAX_MAIN_FREE",
  VELOTAX_MAIN_PRO = "VELOTAX_MAIN_PRO",
  VELOTAX_MAIN_PRO_MONTH = "VELOTAX_MAIN_PRO_MONTH",
  VELOTAX_MAIN_CONCIERGE = "VELOTAX_MAIN_CONCIERGE",
  VELOTAX_MAIN_CONCIERGE_MONTH = "VELOTAX_MAIN_CONCIERGE_MONTH",
  XP_BASIC = "XP_BASIC",
  XP_BASIC_MONTH = "XP_BASIC_MONTH",
  XP_PRO = "XP_PRO",
  XP_PRO_MONTH = "XP_PRO_MONTH",
  XP_CONCIERGE = "XP_CONCIERGE",
  XP_CONCIERGE_MONTH = "XP_CONCIERGE_MONTH"
}

export interface UserPlan {
  type: UserPlanEnum;
  interval: "Anual" | "Mensal";
  title: string;
  price: number;
  discount?: number;
  showDiscount: boolean;
  originalPrice: number;
  includedFeatures: Feature[];
  otherFeatures?: Feature[];
  free?: boolean;
  maskValue?: boolean;
  percentDiscount: number;
  descriptions?: any;
  discountText?: string;
}

export const UserPlans: UserPlan[] = [
  {
    type: UserPlanEnum.VELOTAX_MAIN_PRO,
    interval: "Anual",
    title: "PREMIUM",
    showDiscount: true,
    price: 19.9,
    originalPrice: 29.9,
    percentDiscount: 30,
    discountText: "ou 4 meses grátis",
    maskValue: true,
    includedFeatures: [
      {
        name: "Cálculos 100% precisos",
        icon: <MdDone size={18} color="var(--ant-success-color)" />,
      },
      {
        name: "Conexão oficial com a B3 e com a XP Internacional",
        icon: <MdDone size={18} color="var(--ant-success-color)" />,
      },
      {
        name: "Emissão de DARFs retroativas sem custo adicional",
        icon: <MdDone size={18} color="var(--ant-success-color)" />,
      },
      {
        name: "Informes auxiliares de IR em PDF",
        icon: <MdDone size={18} color="var(--ant-success-color)" />,
      },
    ],
    descriptions: [
      {
        label: "Cálculos automáticos, com multa e juros",
        checked: true,
        icon: <IoIosCalculator size={20} color="rgb(10, 158, 90)" />,
      },
      {
        label: "Integração com XP Internacional",
        checked: true,
        icon: <BiGlobe size={20} color="rgb(10, 158, 90)" />,
      },
      {
        label: "Integração com B3",
        checked: true,
        icon: <IntegrationIcon />,
      },
    ],
  },
  {
    type: UserPlanEnum.VELOTAX_MAIN_PRO_MONTH,
    title: "PREMIUM",
    interval: "Mensal",
    showDiscount: true,
    price: 29.9,
    originalPrice: 29.9,
    percentDiscount: 0,
    maskValue: true,
    includedFeatures: [
      {
        name: "Cálculos 100% precisos",
        icon: <MdDone size={18} color="var(--ant-success-color)" />,
      },
      {
        name: "Conexão oficial com a B3 e com a XP Internacional",
        icon: <MdDone size={18} color="var(--ant-success-color)" />,
      },
      {
        name: "Emissão de DARFs retroativas sem custo adicional",
        icon: <MdDone size={18} color="var(--ant-success-color)" />,
      },
      {
        name: "Informes auxiliares de IR em PDF",
        icon: <MdDone size={18} color="var(--ant-success-color)" />,
      },
    ],
    descriptions: [
      {
        label: "Cálculos automáticos, com multa e juros",
        checked: true,
        icon: <IoIosCalculator size={20} color="rgb(10, 158, 90)" />,
      },
      {
        label: "Integração com XP Internacional",
        checked: true,
        icon: <BiGlobe size={20} color="rgb(10, 158, 90)" />,
      },
      {
        label: "Integração com B3",
        checked: true,
        icon: <IntegrationIcon />,
      },
    ],
  },
];

export const Plans: Plan[] = [
  {
    type: PlanEnum.BASIC_V1,
    title: "basic",
    price: 29.9,
    discount: 75,
    originalPrice: 119.9,
    includedFeatures: [
      {
        name: "Emissão de DASN ilimitados",
        icon: <HiOutlineDocumentReport size={18} />,
      },
      {
        name: "Suporte por e-mail",
        icon: <MdOutlineAlternateEmail size={18} className="fill" />,
      },
    ],
    otherFeatures: OtherFeatures.slice(0, 1),
  },
  {
    type: PlanEnum.PRO_V1,
    title: "plus",
    price: 39.9,
    discount: 75,
    originalPrice: 149.9,
    includedFeatures: [
      {
        name: "Emissão de DAS e DASN ilimitados",
        icon: <HiOutlineDocumentReport size={18} />,
      },
      {
        name: "Suporte por e-mail",
        icon: <MdOutlineAlternateEmail size={18} className="fill" />,
      },
    ],
    otherFeatures: OtherFeatures,
  },
];
